// get client config to configure login page and tool based details
import ClientConfig from 'config'

const SLIDE_PREVIEW_DATA = [{
    _id: 1,
    slideTitle: `About ${ClientConfig.title} About ${ClientConfig.title} About ${ClientConfig.title}`,
    images: [{
        id: 1,
        url: "https://via.placeholder.com/538x303/000/fff.jpg"
      },
      {
        id: 2,
        url: "https://via.placeholder.com/538x303/0000FF/fff.jpg"
      },
      {
        id: 3,
        url: "https://via.placeholder.com/538x303/0000CD/fff.jpg"
      },
      {
        id: 4,
        url: "https://via.placeholder.com/538x303/00008B/fff.jpg"
      },
      {
        id: 5,
        url: "https://via.placeholder.com/538x303/B22222/fff.jpg"
      },
      {
        id: 6,
        url: "https://via.placeholder.com/538x303/FF0000/fff.jpg"
      },
      {
        id: 7,
        url: "https://via.placeholder.com/538x303/8B008B/fff.jpg"
      },
      {
        id: 8,
        url: "https://via.placeholder.com/538x303/008B8B/fff.jpg"
      },
      {
        id: 9,
        url: "https://via.placeholder.com/538x303/FF4500/fff.jpg"
      }
    ],
    boundaryBoxCoOrdinate: [{
        x: 3.2,
        y: 11
      },
      {
        x: 100,
        y: 6.6
      },
      {
        x: 100,
        y: 93.5
      },
      {
        x: 6.4,
        y: 93.5
      }
    ],
    boundaryBoxSize: {
      w: 170,
      h: 100
    },
    slideMetaData: [{
        title: "Author",
        value: "Jon Doe"
      },
      {
        title: "Date Created",
        value: "08/07/2019"
      },
      {
        title: "Date Modified",
        value: "08/07/2019"
      },
      {
        title: "Description",
        value: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      }
    ]
  },
  {
    _id: 2,
    // slide_url: slide,
    slideTitle: `${ClientConfig.title} About`,
    images: [{
        id: 1,
        url: "https://via.placeholder.com/538x303/8B008B/fff.jpg"
      },
      {
        id: 2,
        url: "https://via.placeholder.com/538x303/0000FF/fff.jpg"
      },
      {
        id: 3,
        url: "https://via.placeholder.com/538x303/0000CD/fff.jpg"
      },
      {
        id: 4,
        url: "https://via.placeholder.com/538x303/00008B/fff.jpg"
      },
      {
        id: 5,
        url: "https://via.placeholder.com/538x303/B22222/fff.jpg"
      },
      {
        id: 6,
        url: "https://via.placeholder.com/538x303/FF0000/fff.jpg"
      },
      {
        id: 7,
        url: "https://via.placeholder.com/538x303/000/fff.jpg"
      },
      {
        id: 8,
        url: "https://via.placeholder.com/538x303/008B8B/fff.jpg"
      },
      {
        id: 9,
        url: "https://via.placeholder.com/538x303/FF4500/fff.jpg"
      }
    ],
    boundaryBoxCoOrdinate: [{
        x: 60,
        y: 6.4
      },
      {
        x: 100,
        y: 6.4
      },
      {
        x: 100,
        y: 93.5
      },
      {
        x: 60,
        y: 93.5
      }
    ],
    boundaryBoxSize: {
      w: 100,
      h: 100
    },
    slideMetaData: [{
        title: "Author",
        value: "Jon"
      },
      {
        title: "Date Created",
        value: "08/07/2019"
      },
      {
        title: "Date Modified",
        value: "08/07/2019"
      },
      {
        title: "Description",
        value: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      }
    ]
  }
];

export default SLIDE_PREVIEW_DATA;
